import type { Alert, AlertType } from 'graphql-models';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_ALERT: Alert = {
  id: '1',
  type: 'TEMPERATURE_EXCEEDED' as AlertType,
};

export const alertFactory: Factory<Alert> = (overrides) => ({
  ...MOCK_ALERT,
  ...overrides,
});
